module.exports = __webpack_public_path__ + "static/media/ahri.1fd0f160.png";